import React from 'react';

import { Kind, Message, Text } from '@lumapps/lumx/react';
import { useQueryParams } from '@lumapps/router';
import { useTranslate } from '@lumapps/translations';

import { LOGIN_ERROR_CODES, LOGOUT_URL, LoginErrorCode } from '../../constants';
import { SIGN_IN, LOGOUT } from '../../keys';

import './index.scss';

const CLASSNAME = 'login-message';
export const LoginMessage: React.FC = () => {
    const { translateAndReplace } = useTranslate();
    const { error, accountType, logout, email, correlationId } = useQueryParams();

    const getErrorTranslationKey = () =>
        LOGIN_ERROR_CODES.includes(error as LoginErrorCode)
            ? SIGN_IN[error as LoginErrorCode]
            : SIGN_IN.GENERIC_ERROR_LOGIN;
    const getInfoTranslationKey = () => LOGOUT[accountType as keyof typeof LOGOUT];

    return (
        <>
            {error && getErrorTranslationKey() ? (
                <Message className={CLASSNAME} kind={Kind.error} hasBackground>
                    <Text
                        as="p"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html:
                                accountType && LOGOUT_URL[accountType]
                                    ? translateAndReplace(getErrorTranslationKey(), {
                                          EMAIL: email || '',
                                          LOGOUT_URL: LOGOUT_URL[accountType].url,
                                      })
                                    : translateAndReplace(getErrorTranslationKey(), {
                                          EMAIL: '',
                                          LOGOUT_URL: '#', // To be changed ( Add Okta link href )
                                      }),
                        }}
                    />

                    {correlationId && (
                        <Text as="p">
                            {translateAndReplace(SIGN_IN.GENERIC_ERROR, {
                                CORRELATION_ID: correlationId,
                            })}
                        </Text>
                    )}
                </Message>
            ) : null}
            {accountType && logout === 'true' && getInfoTranslationKey() ? (
                <Message className={CLASSNAME} kind={Kind.info} hasBackground>
                    <Text
                        as="p"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: LOGOUT_URL[accountType]
                                ? translateAndReplace(getInfoTranslationKey(), {})
                                : translateAndReplace(getInfoTranslationKey(), {
                                      LOGOUT_URL: '#', // To be changed ( Add Okta link href )
                                  }),
                        }}
                    />
                </Message>
            ) : null}
        </>
    );
};
